import { isFetchBaseQueryError } from '../redux/api/fetchBaseQueryWithReauth'

export const getErrorMessageCode = (error: unknown): string | null => {
    if (
        isFetchBaseQueryError(error) &&
        typeof error.data === 'object' &&
        error.data !== null &&
        'messageCode' in error.data &&
        typeof error.data.messageCode === 'string'
    ) {
        return error.data.messageCode
    }

    return null
}
